import { ApolloLink, HttpLink } from "@apollo/client";

const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key: string, value: unknown) => (key === "__typename" ? undefined : value);
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
  }
  return forward(operation).map((data) => {
    return data;
  });
});

type UriType = Required<ConstructorParameters<typeof HttpLink>>[0]["uri"];

export const createLink = (headers: { [key: string]: string }, uri: UriType): ApolloLink =>
  ApolloLink.from([
    cleanTypeName,
    new HttpLink({
      uri,
      credentials: "include",
      headers,
    }),
  ]);
